module.exports = __webpack_public_path__ + "media/images/side_bar_open-ef2837d1.svg";